import { render, staticRenderFns } from "./wig-care-hub.vue?vue&type=template&id=14240efc&scoped=true"
import script from "./wig-care-hub.vue?vue&type=script&lang=js"
export * from "./wig-care-hub.vue?vue&type=script&lang=js"
import style0 from "./wig-care-hub.vue?vue&type=style&index=0&id=14240efc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14240efc",
  null
  
)

export default component.exports